// src/MultiRingChart.tsx
import React from "react";
import { Doughnut } from "react-chartjs-2";
import "./chartConfig";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    graphContainer: {
      position: "relative",
      height: 200,
      width: "100%",
      [theme.breakpoints.down("md")]: {
        height: 180,
      },
      [theme.breakpoints.down("sm")]: {
        height: 160,
      },
      [theme.breakpoints.down("xs")]: {
        height: 140,
      },
    },
  })
);

type MultiRingChartProps = {
  data: {
    tips: number;
    subscriptions: number;
    customVideoRequests: number;
    sales: number;
    total: number;
    loading: boolean;
  };
};

const MultiRingChart = ({ data }: MultiRingChartProps) => {
  const classes = useStyles();

  const chartConfigs = [
    {
      data: [data.tips, 100 - data.tips],
      color: "#FE5A97",
      radius: "90%",
      cutout: "90%",
    },
    {
      data: [data.subscriptions, 100 - data.subscriptions],
      color: "#FFD700",
      radius: "80%",
      cutout: "90%",
    },
    {
      data: [data.customVideoRequests, 100 - data.customVideoRequests],
      color: "#808080",
      radius: "70%",
      cutout: "90%",
    },
    {
      data: [data.sales, 100 - data.sales],
      color: "#0E43FB",
      radius: "60%",
      cutout: "90%",
    },
  ];

  return (
    <div className={classes.graphContainer}>
      {chartConfigs.map((config, index) => (
        <div
          key={index}
          style={{
            position: "absolute",
            width: "100%",
            height: "100%",
            top: 0,
            left: 0,
            pointerEvents: "none",
          }}
        >
          <Doughnut
            data={{
              labels: ["Value", "Empty"],
              datasets: [
                {
                  data: config.data,
                  backgroundColor: [config.color, "#2A2A2A"],
                  borderWidth: 0,
                  cutout: config.cutout,
                  radius: config.radius,
                } as any,
              ],
            }}
            options={{
              responsive: true,
              maintainAspectRatio: false,
              rotation: -Math.PI,
              plugins: {
                legend: { display: false },
                tooltip: { enabled: false },
              },
            }}
          />
        </div>
      ))}
      <div
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          color: "white",
          fontSize: 24,
          fontWeight: "bold",
        }}
      >
        {data.loading ? "..." : `$${data.total.toLocaleString()}`}
      </div>
    </div>
  );
};

export default MultiRingChart;
